import React from 'react';
import { CHAT_UI_THEME_TOKENS, DEFAULT_CHAT_UI_THEME } from '../../theme/themeTokens.js';
import { WorkflowCheckpointPanel } from './chatTimelineWorkflowCheckpointPanel.js';
import { buildSystemProcessViewModel } from './chatTimelineSystemProcessModel.js';

const h = React.createElement;
const Fragment = React.Fragment;

function conditionalValue(condition, whenTrue, whenFalse) {
  return condition ? whenTrue : whenFalse;
}

function TimelineProcessCard(props) {
  const { item, themeTokens } = {
    themeTokens: CHAT_UI_THEME_TOKENS[DEFAULT_CHAT_UI_THEME], ...props,
  };
  const {
    candidateGapLabels,
    confirmedSummary,
    currentQuestionText,
    currentStageLabel,
    directionSummary,
    pendingSummary,
    questionWhyNow,
  } = buildSystemProcessViewModel(item);

  if (![directionSummary, candidateGapLabels.length, questionWhyNow, currentQuestionText, confirmedSummary].some(Boolean)) {
    return null;
  }

  return h(
    'div',
    {
      style: {
        color: themeTokens.textPrimary,
        display: 'grid',
        gap: 8,
        padding: '4px 0',
        width: '100%',
      },
    },
    conditionalValue(Boolean(currentStageLabel), h(
      'div',
      {
        style: {
          color: themeTokens.textPrimary,
          fontSize: 13,
          lineHeight: 1.7,
        },
      },
      h('strong', null, '当前步骤：'),
      ` ${currentStageLabel}`
    )),
    h(
      'div',
      {
        style: {
          color: themeTokens.textSecondary,
          fontSize: 12,
          lineHeight: 1.7,
        },
      },
      '当前处于梳理模式：系统会先收敛问题与缺口，右侧持续更新正式梳理结果，暂不把这一步当作最终回答。'
    ),
    conditionalValue(Boolean(confirmedSummary), h(
      'div',
      {
        style: {
          color: themeTokens.textPrimary,
          fontSize: 13,
          lineHeight: 1.7,
        },
      },
      h('strong', null, '已收集信息：'),
      ` ${confirmedSummary}`
    )),
    conditionalValue(Boolean(directionSummary), h(
      'div',
      {
        style: {
          color: themeTokens.textPrimary,
          fontSize: 13,
          lineHeight: 1.7,
        },
      },
      h('strong', null, '方向归纳：'),
      ` ${directionSummary}`
    )),
    conditionalValue(Boolean(pendingSummary), h(
      'div',
      {
        style: {
          color: themeTokens.textPrimary,
          fontSize: 13,
          lineHeight: 1.7,
        },
      },
      h('strong', null, '关键缺口：'),
      ` ${pendingSummary}`
    )),
    conditionalValue(Boolean(questionWhyNow), h(
      'div',
      {
        style: {
          color: themeTokens.textSecondary,
          fontSize: 12,
          lineHeight: 1.7,
        },
      },
      h('strong', null, '下一问依据：'),
      ` ${questionWhyNow}`
    )),
    conditionalValue(Boolean(currentQuestionText), h(
      'div',
      {
        style: {
          color: themeTokens.textPrimary,
          fontSize: 13,
          lineHeight: 1.7,
          paddingTop: 2,
        },
      },
      h('strong', null, '当前优先问题：'),
      ` ${currentQuestionText}`,
      h(
        'div',
        {
          style: {
            color: themeTokens.textSecondary,
            fontSize: 12,
            marginTop: 4,
          },
        },
        '请先回答这一题，系统会基于你的回答重新组织下一问和右侧梳理结果。'
      )
    ))
  );
}

export function renderTimelineDraftChooserNode(props) {
  const { item, themeTokens, defaultExpanded } = {
    themeTokens: CHAT_UI_THEME_TOKENS[DEFAULT_CHAT_UI_THEME], defaultExpanded: false, ...props,
  };
  const record = Object.assign({}, item);
  if (record.type !== 'orchestration_status') {
    return null;
  }

  const children = [];
  const processCard = h(TimelineProcessCard, { item, themeTokens });
  const checkpointPanel = h(WorkflowCheckpointPanel, { item, themeTokens });

  if (processCard) {
    children.push(processCard);
  }
  if (checkpointPanel) {
    children.push(checkpointPanel);
  }

  if (children.length === 0) {
    return null;
  }

  return h(
    'div',
    { className: 'flare-assistant-meta-row' },
    h(
      'details',
      {
        className: 'flare-system-process-disclosure',
        key: `${String([record.id, 'orchestration-status'].find(Boolean))}:${conditionalValue(defaultExpanded, 'live', 'settled')}`,
        open: conditionalValue(defaultExpanded, true, undefined),
        style: { maxWidth: '78%', width: '100%' },
      },
      h('summary', null, '当前梳理过程'),
      h(Fragment, null, ...children)
    )
  );
}
